/* eslint-disable no-async-promise-executor */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ICoordenadas,
  IFilter,
  IQueryParam,
  Rol,
  TipoDispositivo,
} from 'modelos/src';
import { LoginService } from '../modulos/login/login.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageEvent } from '@angular/material/paginator';
import { IRowIcon } from './standalone/tabla/tabla.component';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  public pageSizeOptions = [5, 10, 15, 25, 50, 100, 500];
  public pageSizeOptions2 = [6, 12, 24, 48, 96, 192, 384];

  // static ok = `<span class="material-icons" style="color: green">check</span>`;
  static ok = `<img src="assets/iconos/check.png" alt="OK" style="width: 30px"/>`;
  static okWarning = `<img src="assets/iconos/checkWarning.png" alt="Ok with Warning" style="width: 30px"/>`;
  static notOk = `<img src="assets/iconos/cerrar.png" alt="Not Ok" style="width: 30px"/>`;
  static alerta = `<img src="assets/iconos/alerta.png" alt="alert" style="width: 30px"/>`;
  static vacio = `<p class="no-info">Sin Información</p>`;

  static esModoOscuro(): boolean {
    return localStorage.getItem('temaOscuro') === 'true';
  }

  static parseEstadoRowIcon(
    estado: 'Sin reportar' | 'Ok' | 'Alerta' | undefined,
  ) {
    switch (estado) {
      case 'Alerta': {
        const iconAlerta: IRowIcon = {
          tipo: 'img',
          tooltip: estado,
          icon: 'assets/iconos/alerta.png',
        };
        return iconAlerta;
      }
      case 'Ok': {
        const iconOk: IRowIcon = {
          tipo: 'img',
          tooltip: estado,
          icon: 'assets/iconos/check.png',
        };
        return iconOk;
      }
      default: {
        const iconDefault: IRowIcon = {
          tipo: 'img',
          tooltip: estado,
          icon: 'assets/iconos/checkWarning.png',
        };
        return iconDefault;
      }
    }
  }

  // Presets de Rango de fechas

  static presetAgro = [
    {
      label: 'Mes Anterior',
      from: HelperService.inicioMesAnteriorALaHora(0),
      to: HelperService.inicioMesActualALaHora(0),
    },
    {
      label: 'Últimas 24 horas',
      from: HelperService.fechaHaceDiasALaHora(1, 0),
      to: HelperService.fechaHaceDiasALaHora(0, 0),
    },
    {
      label: 'Últimas 48 horas',
      from: HelperService.fechaHaceDiasALaHora(2, 0),
      to: HelperService.fechaHaceDiasALaHora(0, 0),
    },
    {
      label: 'Últimos 7 días',
      from: HelperService.fechaHaceDiasALaHora(7, 0),
      to: HelperService.fechaHaceDiasALaHora(0, 0),
    },
    {
      label: 'Últimos 30 días',
      from: HelperService.fechaHaceDiasALaHora(30, 0),
      to: HelperService.fechaHaceDiasALaHora(0, 0),
    },
  ];

  static rangePreset = {
    from: HelperService.defaultFromAgro().toISOString(),
    to: HelperService.defaultToAgro().toISOString(),
  };

  static rangePreset1Dia = {
    from: HelperService.defaultFromAgro(1).toISOString(),
    to: HelperService.defaultFromAgro(-1).toISOString(),
  };

  static rangePreset1DiaAndHoras00 = {
    from: HelperService.defaultFromAgroAndHoras(1).toISOString(),
    to: HelperService.defaultFromAgroAndHoras(-1).toISOString(),
  };

  static defaultFromAgro(dias = 2): Date {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() - dias);
    return fecha;
  }

  static defaultFromAgroAndHoras(dias = 2): Date {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() - dias);
    fecha.setHours(0, 0, 0, 0);
    return fecha;
  }

  static defaultToAgro(): Date {
    const fecha = new Date();
    return fecha;
  }

  public static readonly mapOptions: google.maps.MapOptions = {
    zoom: 5,
    streetViewControl: false,
    fullscreenControl: false,
    rotateControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER,
    },
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT,
    },
    mapTypeId: 'roadmap',
    mapTypeControl: true,
    mapTypeControlOptions: {
      mapTypeIds: ['satellite', 'roadmap', 'hybrid', 'terrain'],
      style: google.maps.MapTypeControlStyle.DEFAULT,
      position: google.maps.ControlPosition.TOP_CENTER,
    },
    styles: [
      // { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
      // { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
      // { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
      // {
      //   featureType: 'administrative.country',
      //   elementType: 'geometry.stroke',
      //   stylers: [{ color: '#c8c8c8' }],
      // },
      // {
      //   featureType: 'administrative.province',
      //   elementType: 'geometry.stroke',
      //   stylers: [{ color: '#c8c8c8' }],
      // },
      // {
      //   featureType: 'administrative.locality',
      //   elementType: 'labels.text.fill',
      //   stylers: [{ color: '#d59563' }],
      // },
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }],
      },
      // {
      //   featureType: "poi",
      //   elementType: "labels.text.fill",
      //   stylers: [{ color: "#d59563" }],
      // },
      // {
      //   featureType: 'poi.park',
      //   elementType: 'geometry',
      //   stylers: [{ color: '#263c3f' }],
      // },
      // {
      //   featureType: 'poi.park',
      //   elementType: 'labels.text.fill',
      //   stylers: [{ color: '#6b9a76' }],
      // },
      // {
      //   featureType: 'road',
      //   elementType: 'geometry',
      //   stylers: [{ color: '#38414e' }],
      // },
      // {
      //   featureType: 'road',
      //   elementType: 'geometry.stroke',
      //   stylers: [{ color: '#212a37' }],
      // },
      // {
      //   featureType: 'road',
      //   elementType: 'labels.text.fill',
      //   stylers: [{ color: '#9ca5b3' }],
      // },
      // {
      //   featureType: 'road.highway',
      //   elementType: 'geometry',
      //   stylers: [{ color: '#746855' }],
      // },
      // {
      //   featureType: 'road.highway',
      //   elementType: 'geometry.stroke',
      //   stylers: [{ color: '#1f2835' }],
      // },
      // {
      //   featureType: 'road.highway',
      //   elementType: 'labels.text.fill',
      //   stylers: [{ color: '#f3d19c' }],
      // },
      {
        featureType: 'transit',
        stylers: [{ visibility: 'off' }],
      },
      // {
      //   featureType: 'transit',
      //   elementType: 'geometry',
      //   stylers: [{ color: '#2f3948' }],
      // },
      // {
      //   featureType: 'transit.station',
      //   elementType: 'labels.text.fill',
      //   stylers: [{ color: '#d59563' }],
      // },
      // {
      //   featureType: 'water',
      //   elementType: 'geometry',
      //   stylers: [{ color: '#17263c' }],
      // },
      // {
      //   featureType: 'water',
      //   elementType: 'labels.text.fill',
      //   stylers: [{ color: '#515c6d' }],
      // },
      // {
      //   featureType: 'water',
      //   elementType: 'labels.text.stroke',
      //   stylers: [{ color: '#17263c' }],
      // },
    ],
  };

  public static readonly mapOptionsMarkerPicker: google.maps.MapOptions = {
    mapTypeId: 'satellite',
    scrollwheel: null,
    gestureHandling: 'cooperative',
    zoom: 15,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT,
    },
    mapTypeControlOptions: {
      mapTypeIds: ['satellite', 'roadmap', 'hybrid', 'terrain'],
      style: google.maps.MapTypeControlStyle.DEFAULT,
    },
  };

  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  get dark(): boolean {
    return !!localStorage.getItem('temaOscuro');
  }

  constructor(
    private snackBar: MatSnackBar,
    private breakpointObserver: BreakpointObserver,
  ) {}

  //
  public static filterToObject(filter?: string): IFilter {
    try {
      return JSON.parse(filter || '{}');
    } catch {
      return {};
    }
  }

  private padZero(str: string, len: number = 2): string {
    const zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }
  public contrastColor(hex?: string, bw: boolean = true) {
    if (!hex) {
      return '#000000';
    }
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color.');
    }
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      // https://stackoverflow.com/a/3943023/112731
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
    // invert color components
    const r_str = (255 - r).toString(16);
    const g_str = (255 - g).toString(16);
    const b_str = (255 - b).toString(16);
    // pad each with zeros and return
    return (
      '#' + this.padZero(r_str) + this.padZero(g_str) + this.padZero(b_str)
    );
  }

  public getCurrentHostname() {
    return window.location.hostname;
  }

  public getPageSize(nombreTabla?: string): number {
    const size =
      localStorage.getItem(`page-${nombreTabla}`) ||
      localStorage.getItem(nombreTabla || 'pageSize');
    return size ? +size : this.pageSizeOptions[2];
  }

  public setPageSize($event: PageEvent, nombreTabla?: string): void {
    localStorage.setItem(nombreTabla || 'pageSize', `${$event.pageSize}`);
  }

  public static getQueryParams(queryParams?: IQueryParam) {
    let params = new HttpParams();
    if (queryParams) {
      const keysIgnorar = [
        'page',
        'limit',
        'sort',
        'populate',
        'select',
        'filter',
      ];
      if (queryParams?.page || queryParams?.page === 0) {
        params = params.set('page', queryParams.page.toString());
      }
      if (queryParams?.limit || queryParams?.limit === 0) {
        params = params.set('limit', queryParams.limit.toString());
      }
      if (queryParams?.sort) {
        params = params.set('sort', queryParams.sort);
      }
      if (queryParams?.populate) {
        params = params.set('populate', queryParams.populate);
      }
      if (queryParams?.select) {
        params = params.set('select', queryParams.select);
      }
      if (queryParams?.filter) {
        params = params.set('filter', queryParams.filter);
      }

      for (const key in queryParams) {
        if (!keysIgnorar.includes(key)) {
          params = params.set(key, queryParams[key]);
        }
      }
    }
    return params;
  }

  // Usuarios

  public static puedeVerTipoDispositivo(tipo: TipoDispositivo) {
    const user = LoginService.getUsuario();
    const permiso = user.permisos.find((x) =>
      x.tiposDispositivo?.includes(tipo),
    );
    return !!permiso;
  }

  public static puedeEditar() {
    const user = LoginService.getUsuario();
    const permisosValidos = ['Admin', 'Escritura'];
    const nivelesValidos = ['Cliente', 'Establecimiento'];
    const permiso = user.permisos.find(
      (x) =>
        permisosValidos.includes(x.rol) && nivelesValidos.includes(x.nivel),
    );
    return !!permiso;
  }

  public static puedeEliminar() {
    const user = LoginService.getUsuario();
    const permisosValidos = ['Admin', 'Escritura'];
    const nivelesValidos = ['Cliente', 'Establecimiento'];
    const permiso = user.permisos.find(
      (x) =>
        permisosValidos.includes(x.rol) && nivelesValidos.includes(x.nivel),
    );
    return !!permiso;
  }

  public static esAdminCliente() {
    const user = LoginService.getUsuario();
    const permiso = user.permisos.find(
      (x) => x.nivel === 'Cliente' && x.rol === 'Admin',
    );
    return !!permiso;
  }

  static esAdminEstablecimiento(idEstablecimiento: string) {
    const user = LoginService.getUsuario();
    const permiso = user.permisos.find(
      (x) =>
        x.nivel === 'Establecimiento' &&
        x.rol === 'Admin' &&
        x.idEstablecimiento === idEstablecimiento,
    );
    return !!permiso;
  }

  static esAdminEstablecimientoCualquiera() {
    const user = LoginService.getUsuario();
    const permiso = user.permisos.find(
      (x) => x.nivel === 'Establecimiento' && x.rol === 'Admin',
    );
    return !!permiso;
  }

  static usuarioTieneRol(rol: Rol) {
    const user = LoginService.getUsuario();
    const permiso = user.permisos.find((x) => x.rol === rol);
    return !!permiso;
  }

  public puedeCrear() {
    const roles: Rol[] = ['Admin', 'Escritura'];
    const user = LoginService.getUsuario();
    const permiso = user.permisos.find((x) => roles.includes(x.rol));
    return !!permiso;
  }
  public puedeEditar() {
    const roles: Rol[] = ['Admin', 'Escritura'];
    const user = LoginService.getUsuario();
    const permiso = user.permisos.find((x) => roles.includes(x.rol));
    return !!permiso;
  }
  public puedeEliminar() {
    const roles: Rol[] = ['Admin', 'Escritura'];
    const user = LoginService.getUsuario();
    const permiso = user.permisos.find((x) => roles.includes(x.rol));
    return !!permiso;
  }

  // Notificaciones
  public notifError(error: any): void {
    console.log(error);
    const mensaje =
      error?.error?.mensaje ||
      error?.mensaje ||
      error?.error?.message ||
      error?.message ||
      'Error desconocido, ver logs';
    console.error(mensaje);
    this.snackBar.open(mensaje, 'Cerrar', { panelClass: ['red-snackbar'] });
  }
  public notifSuccess(mensaje: string): void {
    console.log(mensaje);
    this.snackBar.open(mensaje, 'Cerrar', {
      duration: 3000,
      panelClass: ['green-snackbar'],
    });
  }
  public notifWarn(mensaje: string): void {
    console.log(mensaje);
    this.snackBar.open(mensaje, 'Cerrar', { panelClass: ['yellow-snackbar'] });
  }

  // Mapa
  public static async getCurrentPosition(): Promise<ICoordenadas> {
    return new Promise(async (resolve) => {
      const ubicacionBase: ICoordenadas = {
        lat: -35.5836812,
        lng: -58.0128784,
      };
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const ubicacion: ICoordenadas = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            resolve(ubicacion);
          },
          () => {
            console.error('Ubicacion no aceptada');
            resolve(ubicacionBase);
          },
        );
      } else {
        resolve(ubicacionBase);
      }
    });
  }

  public static getCentro(coordenadas?: ICoordenadas[]): ICoordenadas | void {
    if (coordenadas?.length) {
      const newPolygon: ICoordenadas[] = JSON.parse(
        JSON.stringify(coordenadas),
      );
      const longitudes = newPolygon.map((i) => i.lat);
      const latitudes = newPolygon.map((i) => i.lng);
      latitudes.sort((a, b) => a - b);
      longitudes.sort((a, b) => a - b);
      const lowX = latitudes[0];
      const highX = latitudes[latitudes.length - 1];
      const lowy = longitudes[0];
      const highy = longitudes[latitudes.length - 1];
      const centerX = lowX + (highX - lowX) / 2;
      const centerY = lowy + (highy - lowy) / 2;
      const center: ICoordenadas = {
        lng: centerX,
        lat: centerY,
      };
      return center;
    }
  }
  public idioma(idioma: string, ruta = '/') {
    return `https://${this.getCurrentHostname()}/${idioma}/#${ruta}`;
  }

  static distanciaEnMetros(punto1?: ICoordenadas, punto2?: ICoordenadas) {
    if (!punto1 || !punto2) return 0;
    if (+punto1?.lat && +punto1?.lng && +punto2?.lat && +punto2?.lng) {
      const R = 6371e3; // metres
      const φ1 = punto1.lat * (Math.PI / 180); // φ, λ in radians
      const φ2 = punto2.lat * (Math.PI / 180);
      const Δφ = (punto2.lat - punto1.lat) * (Math.PI / 180);
      const Δλ = (punto2.lng - punto1.lng) * (Math.PI / 180);

      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const d = R * c; // in metres
      return d;
    }
    return 0;
  }

  static estaDentro(
    ubicacion: ICoordenadas,
    poligono?: ICoordenadas[],
  ): boolean {
    if (ubicacion && poligono) {
      const x = ubicacion.lat;
      const y = ubicacion.lng;
      let inside = false;
      for (let i = 0, j = poligono.length - 1; i < poligono.length; j = i++) {
        const xi = poligono[i].lat;
        const yi = poligono[i].lng;
        const xj = poligono[j].lat;
        const yj = poligono[j].lng;
        const intersect =
          yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) {
          inside = !inside;
        }
      }
      return inside;
    }
    return false;
  }

  // Tiempo
  static tiempoTranscurrido(fecha?: Date | string): string {
    if (fecha) {
      return moment(moment.utc(fecha), 'YYYYMMDD').fromNow();
    }
    return '';
  }

  // Colores

  static randomColorFromString(s: string) {
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
      // tslint:disable-next-line: no-bitwise
      hash = s.charCodeAt(i) + ((hash << 5) - hash);
    }
    const c = (hash & 0x00ffffff).toString(16).toUpperCase();
    return '#' + '00000'.substring(0, 6 - c.length) + c;
  }

  // IGM BOMBEO V2

  public calcularIGM(nivel: number, igm: number) {
    return igm - nivel;
  }

  // Factor Corrección
  public calcularCorreccion(pulsos: number, factor?: number) {
    return pulsos * (factor || 1);
  }

  // Fechas (Robado de gas)
  static inicioMesAnteriorALaHora(hora: number) {
    const d = new Date();
    d.setUTCMonth(d.getUTCMonth() - 1);
    d.setUTCDate(1);
    d.setUTCHours(hora + 3, 0, 0, 0);
    return d.toISOString();
  }

  static inicioMesActualALaHora(hora: number) {
    const d = new Date();
    d.setUTCDate(1);
    d.setUTCHours(hora + 3, 0, 0, 0);
    return d.toISOString();
  }

  static fechaHaceDiasALaHora(dias: number, hora: number) {
    const d = new Date();
    d.setUTCDate(d.getUTCDate() - dias);
    d.setUTCHours(hora + 3, 0, 0, 0);
    return d.toISOString();
  }

  static mesAnteriorALasSeis(fecha: Date) {
    const fechaAux = new Date(fecha);
    fechaAux.setHours(6, 0, 0, 0);
    fechaAux.setMonth(fecha.getMonth() - 1);
    return fechaAux;
  }

  static mesAnteriorALasSiete(fecha: Date) {
    const fechaAux = new Date(fecha);
    fechaAux.setHours(7, 0, 0, 0);
    fechaAux.setMonth(fecha.getMonth() - 1);
    return fechaAux;
  }

  static dateAtSixHours(fecha: Date) {
    const fechaAux = new Date(fecha);
    fechaAux.setHours(6, 0, 0, 0);
    return fechaAux;
  }

  static dateAtSevenHours(fecha: Date) {
    const fechaAux = new Date(fecha);
    fechaAux.setHours(7, 0, 0, 0);
    return fechaAux;
  }

  static fechaGas(dias: number): string {
    const fecha = new Date();
    fecha.setHours(6, 0, 0, 0);
    fecha.setDate(fecha.getDate() - dias);
    return fecha.toISOString();
  }

  static mesAnterior(fecha: Date) {
    const fechaAux = new Date(fecha);
    fechaAux.setMonth(fecha.getMonth() - 1);
    return fechaAux;
  }

  static fechaAnterior(dias: number) {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() - dias);
    return fecha;
  }

  static tomorrow(fecha: Date) {
    const fechaAux = new Date(fecha);
    fechaAux.setDate(fecha.getDate() + 1);
    return fechaAux;
  }

  static roundTo(n: number, digits: number) {
    let negative = false;
    if (digits === undefined) {
      digits = 0;
    }
    if (n < 0) {
      negative = true;
      n = n * -1;
    }
    const multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = +(Math.round(n) / multiplicator).toFixed(digits);
    if (negative) {
      n = +(n * -1).toFixed(digits);
    }
    return n;
  }
}
